module.exports = __webpack_public_path__ + "static/img/Stephen_Coniglio_mobile.7b6f2c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stephen_Coniglio_mobile.jpg
// module id = lcnM
// module chunks = 0